import { _ as F } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import { zIndices as nr } from "@ucl/shared-component-foundations";
import { c as p } from "./index-8b07dec9.js";
import { createContext as sr, useState as z, useContext as K, useRef as k, useEffect as pr } from "react";
import "./es.object.keys-9d66766f.js";
import { usePopoverIndex as lr } from "./usePopoverIndex.js";
import { getAriaProps as N } from "./aria.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.is-array-7a29277f.js";
import "./es.object.to-string-f55666a8.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as mr } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as E } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { Disclosures as dr } from "./disclosure.js";
import { _ as C } from "./index-f5b44da3.js";
import { FocusTrap as cr } from "./focusTrap.js";
import { CloseButton as q } from "./closeButton.js";
import { E as $ } from "./index-f2264f1e.js";
import { uniqueId as ur } from "./uniqueId.js";
import m, { css as d } from "styled-components";
import { hTag as R } from "./hTag.js";
import { m as V, A as wr } from "./index-55eee02a.js";
import { jsx as a, jsxs as w } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./es.array.filter-4e9c9996.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./iterate-13ada9e5.js";
import "./classof-21a3574e.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./function-apply-4756dee6.js";
import "./to-string-92a62764.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./inherit-if-required-f068457b.js";
import "./es.regexp.to-string-e800d529.js";
import "./set-species-5ede2ed0.js";
import "./es.string.search-d27ec57a.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.array.from-fe752fa6.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./es.function.name-b230e7d4.js";
import "./es.date.to-string-6ed49878.js";
import "./es.parse-float-020a2ae0.js";
import "./es.string.iterator-5de8a61e.js";
import "./index-5d0f31c6.js";
import "./an-instance-6efcfd6c.js";
import "@ucl/shared-icons";
import "@ucl/ucl-translation";
import "react-dom";
import "./useWindowSize.js";
import "./helperText.js";
import "./es.array.join-c1bca812.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./label.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./popupTip-06ee114c.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./divider.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./string-html-forced-a746405b.js";
import "./tooltip.js";
import "./carousel.js";
import "./useMediaQuery.js";
import "./iconButton.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./es.global-this-a7f40ce1.js";
import "./badge.js";
import "./es.string.small-23219181.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./tslib.es6-59e1c9d8.js";
var vr = /* @__PURE__ */ m(V.div).withConfig({
  displayName: "drawerstyles__DrawerContainer",
  componentId: "orngm2-0"
})(["&.Drawer__Container{", "}"], function(t) {
  var r = t.theme.components.drawer;
  return d(r.DrawerContainer);
}), hr = /* @__PURE__ */ m.div.withConfig({
  displayName: "drawerstyles__Overlay",
  componentId: "orngm2-1"
})(["&.Drawer__Overlay{", "}"], function(t) {
  var r = t.theme.components.drawer;
  return d(r.Overlay);
}), Z = /* @__PURE__ */ m.div.withConfig({
  displayName: "drawerstyles__DrawerHeaderWrapper",
  componentId: "orngm2-2"
})(["&.Drawer__HeaderWrapper{", "}"], function(t) {
  var r = t.theme.components.drawer;
  return d(r.DrawerHeaderWrapper);
}), Dr = /* @__PURE__ */ m.div.withConfig({
  displayName: "drawerstyles__DrawerFooterWrapper",
  componentId: "orngm2-3"
})(["&.Drawer__FooterWrapper{", "}"], function(t) {
  var r = t.theme.components.drawer;
  return d(r.DrawerFooterWrapper);
}), _r = /* @__PURE__ */ m.div.withConfig({
  displayName: "drawerstyles__DrawerChildrenWrapper",
  componentId: "orngm2-4"
})(["&.Drawer__ChildrenWrapper{", "}"], function(t) {
  var r = t.theme.components.drawer;
  return d(r.DrawerChildrenWrapper);
}), U = /* @__PURE__ */ m.span.withConfig({
  displayName: "drawerstyles__DrawerTitleWrapper",
  componentId: "orngm2-5"
})(["&.Drawer__TitleWrapper{", "}"], function(t) {
  var r = t.theme.components.drawer;
  return d(r.DrawerTitleWrapper);
}), X = /* @__PURE__ */ m.span.withConfig({
  displayName: "drawerstyles__DrawerHeaderButtonsWrapper",
  componentId: "orngm2-6"
})(["&.Drawer__HeaderButtonsWrapper{", "}"], function(t) {
  var r = t.theme.components.drawer;
  return d(r.DrawerHeaderButtonsWrapper);
}), G = /* @__PURE__ */ m.div.withConfig({
  displayName: "drawerstyles__HeaderActionButtonWrapper",
  componentId: "orngm2-7"
})(["&.Drawer__Header--ActionButtonWrapper{", "}"], function(t) {
  var r = t.theme.components.drawer;
  return d(r.HeaderActionButtonWrapper);
}), J = /* @__PURE__ */ m(R).withConfig({
  displayName: "drawerstyles__Title",
  componentId: "orngm2-8"
})(["&.Drawer__Title{", "}"], function(t) {
  var r = t.theme.components.drawer;
  return d(r.Title);
}), Q = /* @__PURE__ */ m(R).withConfig({
  displayName: "drawerstyles__SubtitleWrapper",
  componentId: "orngm2-9"
})(["&.Drawer__SubtitleWrapper{", "}"], function(t) {
  var r = t.theme.components.drawer;
  return d(r.SubtitleWrapper);
}), Y = /* @__PURE__ */ m.span.withConfig({
  displayName: "drawerstyles__BadgeWrapper",
  componentId: "orngm2-10"
})(["&.Drawer__BadgeWrapper{", "}"], function(t) {
  var r = t.theme.components.drawer;
  return d(r.BadgeWrapper);
}), L = /* @__PURE__ */ sr({}), gr = ["onClose", "accessibilityOptions"], rr = function(r) {
  var o = r.headingLevel, e = r.children, n = r.className;
  return /* @__PURE__ */ a(J, {
    className: p(["Drawer__Title", n]),
    as: o || "h1",
    children: e
  });
}, er = function(r) {
  var o = r.headingLevel, e = r.children;
  return /* @__PURE__ */ a(Q, {
    className: "Drawer__SubtitleWrapper",
    as: o || "h2",
    children: e
  });
}, tr = function(r) {
  var o = r.onClose, e = r.accessibilityOptions, n = F(r, gr), i = N("button", Object.assign({
    ariaLabel: "drawer-close-button"
  }, (e == null ? void 0 : e.closeButton) || {}));
  return /* @__PURE__ */ a(q, Object.assign({
    onClick: o,
    size: "medium",
    role: "button"
  }, i, {
    id: "DrawerCloseButton"
  }, n));
}, or = function(r) {
  var o = r.dropdownMenuItems, e = r.accessibilityOptions, n = z(!1), i = n[0], l = n[1], D = K(L), v = D.id, h = e == null ? void 0 : e.menuIcon, _ = N("button", Object.assign({
    ariaLabel: "dropdown menu",
    ariaExpanded: i ? "true" : "false",
    ariaControls: "list-" + v
  }, h));
  return /* @__PURE__ */ a(G, {
    className: p(["Drawer__Header--ActionButtonWrapper"]),
    onKeyDown: function(s) {
      s.key === "Escape" && i && s.stopPropagation();
    },
    children: (o == null ? void 0 : o.items.length) && /* @__PURE__ */ w(C, {
      menuOpen: i,
      className: "menu-alignment",
      menuDirection: "down_right",
      handleMenuOpen: function(s) {
        return l(s);
      },
      onChange: function(s, f) {
        return o.onChange && (o == null ? void 0 : o.onChange(s, f));
      },
      uniqueIdentifier: v,
      children: [/* @__PURE__ */ a(C.Control, {
        children: /* @__PURE__ */ a($, Object.assign({
          active: i,
          id: "control-" + v,
          role: "button"
        }, _))
      }), o && o.items.map(function(c, s) {
        return /* @__PURE__ */ a(C.Item, Object.assign({}, c), s);
      })]
    })
  });
}, O = function(r) {
  var o = r.children, e = r.drawerBadge, n = r.className, i = E(o, {
    title: rr,
    subTitle: er,
    closeButton: tr,
    actionButton: or
  }, E.PickType.ALL);
  return /* @__PURE__ */ w(Z, {
    className: p(["Drawer__HeaderWrapper", n]),
    children: [/* @__PURE__ */ w(U, {
      className: p(["Drawer__TitleWrapper"]),
      children: [i.rest, i.title, i.subTitle]
    }), /* @__PURE__ */ w(X, {
      className: p(["Drawer__HeaderButtonsWrapper"]),
      children: [e && /* @__PURE__ */ a(Y, {
        className: "Drawer__BadgeWrapper",
        children: e
      }), i.actionButton, i.closeButton]
    })]
  });
};
O.Title = rr;
O.SubTitle = er;
O.ActionButton = or;
O.CloseButton = tr;
var br = ["isOpen", "size", "placement", "children", "onClose", "accessibilityOptions", "id", "_noBackDrop", "_disableTransition", "className"], yr = "Drawer", kt = function(r) {
  var o, e = r.titleProp, n = e === void 0 ? {
    title: "Drawer title",
    headingLevel: "h1"
  } : e, i = r.subTitleProp, l = r.dropdownMenuItems, D = r.drawerBadge, v = r.onClose, h = r.accessibilityOptions, _ = h === void 0 ? {} : h, c = z(!1), s = c[0], f = c[1], H = K(L), g = H.id, P = _.closeButton, x = _.menuIcon, b = N("button", Object.assign({
    ariaLabel: "drawer-close-button"
  }, P)), B = N("button", Object.assign({
    ariaLabel: "dropdown menu",
    ariaExpanded: s ? "true" : "false",
    ariaControls: "list-" + g
  }, x));
  return /* @__PURE__ */ w(Z, {
    className: p(["Drawer__HeaderWrapper"]),
    children: [/* @__PURE__ */ w(U, {
      className: p(["Drawer__TitleWrapper"]),
      children: [/* @__PURE__ */ a(J, {
        className: "Drawer__Title",
        as: n.headingLevel,
        id: "drawer-title-" + g,
        children: n.title
      }), i && /* @__PURE__ */ a(Q, {
        className: "Drawer__SubtitleWrapper",
        as: (i == null ? void 0 : i.headingLevel) || "h2",
        children: i.subTitle
      })]
    }), /* @__PURE__ */ w(X, {
      className: p(["Drawer__HeaderButtonsWrapper"]),
      children: [D && /* @__PURE__ */ a(Y, {
        className: "Drawer__BadgeWrapper",
        children: D
      }), /* @__PURE__ */ a(G, {
        className: p(["Drawer__Header--ActionButtonWrapper"]),
        onKeyDown: function(u) {
          u.code === "Escape" && s && u.stopPropagation();
        },
        children: !!(l != null && (o = l.items) != null && o.length) && /* @__PURE__ */ w(C, {
          menuOpen: s,
          className: "menu-alignment",
          menuDirection: "down_right",
          handleMenuOpen: function(u) {
            return f(u);
          },
          onChange: function(u, A) {
            return l.onChange && (l == null ? void 0 : l.onChange(u, A));
          },
          uniqueIdentifier: g,
          children: [/* @__PURE__ */ a(C.Control, {
            children: /* @__PURE__ */ a($, Object.assign({
              active: s,
              id: "control-" + g,
              role: "button"
            }, B))
          }), l && l.items.map(function(y, u) {
            return /* @__PURE__ */ a(C.Item, Object.assign({}, y), u);
          })]
        })
      }), /* @__PURE__ */ a(q, Object.assign({
        onClick: v,
        size: "medium",
        role: "button",
        id: "DrawerCloseButton"
      }, b))]
    })]
  });
}, Cr = function(r) {
  var o = r.children, e = r.className;
  return /* @__PURE__ */ a(Dr, {
    className: p(["Drawer__FooterWrapper"], e),
    children: o
  });
}, fr = function(r) {
  var o = r.children, e = r.disclosures, n = r.className;
  return /* @__PURE__ */ w(_r, {
    className: p(["Drawer__ChildrenWrapper", n]),
    children: [o, e && /* @__PURE__ */ a(dr, {
      disclosureContent: e == null ? void 0 : e.disclosureContent,
      id: e == null ? void 0 : e.id,
      className: e == null ? void 0 : e.className,
      disclosureTitleColor: e == null ? void 0 : e.disclosureTitleColor,
      style: e == null ? void 0 : e.style
    })]
  });
}, Br = {
  open: {
    x: "-100%"
  },
  closed: {
    x: 0
  }
}, Wr = {
  open: {
    x: 0
  },
  closed: {
    x: "-100%"
  }
}, I = function(r) {
  var o = r.isOpen, e = r.size, n = e === void 0 ? "medium" : e, i = r.placement, l = i === void 0 ? "right" : i, D = r.children, v = r.onClose, h = r.accessibilityOptions, _ = h === void 0 ? {} : h, c = r.id, s = r._noBackDrop, f = r._disableTransition, H = r.className, g = F(r, br), P = mr({
    label: "Drawer"
  }), x = lr(o, I.ZIndex), b = k(null), B = k(ur(c ?? yr)), y = {
    id: B.current
  };
  pr(function() {
    var W = b.current;
    if (W) {
      var T, j;
      (T = b.current) == null || T.setAttribute("tabindex", "-1"), (j = b.current) == null || j.focus();
      var M = W.querySelector("#DrawerCloseButton"), S = function(ar) {
        var ir = ar.code === "Tab";
      };
      return M == null || M.focus(), W.addEventListener("keydown", S), function() {
        W.removeEventListener("keydown", S);
      };
    }
    o ? document.body.style.overflow = "hidden" : document.body.style.overflow = "";
  }, [o]);
  var u = N("dialog", Object.assign({
    ariaModal: !0,
    ariaLabelledBy: "drawer-title-" + B.current
  }, _)), A = function(T) {
    T.code === "Escape" && v && v();
  };
  return /* @__PURE__ */ a(L.Provider, {
    value: y,
    children: /* @__PURE__ */ a(wr, {
      children: o && /* @__PURE__ */ w(V.div, Object.assign({
        className: p(["Drawer", H])
      }, g, {
        children: [o && /* @__PURE__ */ a(hr, {
          className: p(["Drawer__Overlay", {
            "Drawer__Overlay--noBackDrop": s
          }]),
          onClick: v
        }), /* @__PURE__ */ a(cr, {
          open: !0,
          disableEnforceFocus: !0,
          children: /* @__PURE__ */ a(vr, Object.assign({
            style: {
              zIndex: x
            },
            className: p(["Drawer__Container", "Drawer__Container--" + l, "Drawer__Container--" + n, {
              "Drawer__Container--noBackDrop": s
            }]),
            ref: b,
            initial: "closed",
            animate: o ? "open" : "closed",
            exit: "closed",
            variants: l === "right" ? Br : Wr,
            transition: f ? {
              duration: 0
            } : {
              duration: 0.3
            },
            size: n,
            placement: l,
            onKeyDown: A,
            id: B.current,
            role: "dialog"
          }, u, P, {
            children: D
          }))
        })]
      }))
    })
  });
};
I.ZIndex = nr.modal;
I.Header = O;
I.Footer = Cr;
I.Content = fr;
export {
  I as Drawer,
  fr as DrawerContent,
  Cr as DrawerFooter,
  kt as DrawerHeader
};
